import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { MapPin } from 'lucide-react';

const LocationChart = () => {
  const data = [
    { location: 'Plant A', incidents: 12 },
    { location: 'Warehouse B', incidents: 8 },
    { location: 'Site C', incidents: 15 },
    { location: 'Lab', incidents: 5 },
    { location: 'Office', incidents: 3 }
  ];

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <div className="flex items-center gap-2 mb-4">
        <MapPin className="w-5 h-5 text-blue-600" />
        <h3 className="text-lg font-semibold text-gray-900">Location Comparison</h3>
      </div>
      
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="location" stroke="#6b7280" />
            <YAxis stroke="#6b7280" />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: '#fff', 
                border: '1px solid #e5e7eb',
                borderRadius: '8px'
              }}
            />
            <Legend />
            <Bar dataKey="incidents" fill="#3b82f6" name="Total Incidents" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default LocationChart;